import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { CheckCircle, Package, Mail } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function ThankYouPage() {
  const location = useLocation();
  const state = location.state as {
    orderId: string;
    total: number;
    customerName: string;
  } | null;
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4" data-id="element-386">
      <div className="max-w-2xl w-full" data-id="element-387">
        <div className="bg-white rounded-lg shadow-xl p-8 md:p-12 text-center" data-id="element-388">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-389">
            <CheckCircle className="w-12 h-12 text-green-600" data-id="element-390" />
          </div>

          <h1 className="text-3xl md:text-4xl font-black text-[#1a1a1a] mb-3" data-id="element-391">
            Order Confirmed!
          </h1>
          <p className="text-xl text-gray-600 mb-8" data-id="element-392">
            Thank you{state?.customerName ? `, ${state.customerName}` : ''}!
            Your order has been received.
          </p>

          {state && <div className="bg-[#FDB913]/10 border-2 border-[#FDB913] rounded-lg p-6 mb-8" data-id="element-393">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-394">
                <div data-id="element-395">
                  <span className="text-sm text-gray-600 block mb-1" data-id="element-396">
                    Order Number
                  </span>
                  <span className="font-mono font-bold text-lg text-[#1a1a1a]" data-id="element-397">
                    {state.orderId}
                  </span>
                </div>
                <div data-id="element-398">
                  <span className="text-sm text-gray-600 block mb-1" data-id="element-399">
                    Total Amount
                  </span>
                  <span className="font-bold text-lg text-[#1a1a1a]" data-id="element-400">
                    ${state.total.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8 text-left" data-id="element-401">
            <div className="flex gap-4 p-4 bg-gray-50 rounded-lg" data-id="element-402">
              <Package className="w-6 h-6 text-[#FDB913] flex-shrink-0 mt-1" data-id="element-403" />
              <div data-id="element-404">
                <h3 className="font-bold text-[#1a1a1a] mb-1" data-id="element-405">Fast Shipping</h3>
                <p className="text-sm text-gray-600" data-id="element-406">
                  Your order will ship within 1-2 business days.
                </p>
              </div>
            </div>
            <div className="flex gap-4 p-4 bg-gray-50 rounded-lg" data-id="element-407">
              <Mail className="w-6 h-6 text-[#FDB913] flex-shrink-0 mt-1" data-id="element-408" />
              <div data-id="element-409">
                <h3 className="font-bold text-[#1a1a1a] mb-1" data-id="element-410">
                  Order Confirmation
                </h3>
                <p className="text-sm text-gray-600" data-id="element-411">
                  Check your email for order details and tracking.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-412">
            <Link to="/" data-id="element-413">
              <Button size="lg" className="w-full sm:w-auto" data-id="element-414">
                Continue Shopping
              </Button>
            </Link>
            <Link to="/" data-id="element-415">
              <Button variant="outline" size="lg" className="w-full sm:w-auto" data-id="element-416">
                Back to Home
              </Button>
            </Link>
          </div>
        </div>

        <p className="text-center text-gray-500 text-sm mt-6" data-id="element-417">
          Questions? Contact us at{' '}
          <a href="mailto:sales@precisionpro.com" className="text-[#FDB913] hover:underline" data-id="element-418">
            sales@precisionpro.com
          </a>
        </p>
      </div>
    </div>;
}